import React, { useState, useEffect } from "react";
import "./style.css";
import axios from 'axios';
import AOS from 'aos';
import { getAnalytics, logEvent } from "firebase/analytics";
import { Link } from 'react-router-dom';
import { Header_New } from "../../../components/Header_new"; 

const Imprint = () => {
  const analytics = getAnalytics();
  logEvent(analytics, 'imprint');

  const [randomMargins, setRandomMargins] = useState([]);
  const contentBlocks = [
    {
      headerText: "Impressum",
      paraText: "Angaben gemäß § 5 TMG:\nTristan Juri Schiemenz\n Schmogrower Straße 25\n03096 Werben\n\nKontakt:\n E-Mail: tristanschiemenz(at)gmail.com\n\nHaftungsausschluss für KI-generierte Inhalte\nDie Inhalte dieser Webseite enthalten Beiträge, die durch künstliche Intelligenz (KI) generiert wurden. Während wir uns bemühen, sicherzustellen, dass diese Inhalte nützlich, informativ und rechtlich unbedenklich sind, übernehmen wir keine Haftung für die Genauigkeit, Vollständigkeit oder Angemessenheit dieser KI-generierten Inhalte. Die Verwendung der Inhalte erfolgt auf eigenes Risiko der Nutzer. Wir übernehmen keine Verantwortung für Handlungen, die auf Grundlage dieser Inhalte unternommen werden, noch für direkte oder indirekte Folgen, die aus der Verwendung dieser Inhalte entstehen könnten.\nBitte beachten Sie, dass KI-generierte Inhalte möglicherweise nicht die Meinungen oder Ansichten von Tristan Schiemenz widerspiegeln. Bei Fragen oder Bedenken zu spezifischen Inhalten kontaktieren Sie uns bitte unter tristanschiemenz(at)gmail.com."
    }
  ];

  const getRandomMargin = () => {
    return Math.floor(Math.random() * 2000) - 1000 + 'px';
  };
  useEffect(() => {
    AOS.init();
    setRandomMargins([
      getRandomMargin(),
      getRandomMargin(),
      getRandomMargin(),
      getRandomMargin()
    ]);
  }, []);
  return (
    <div className="homepage">
      <div className="main-content">
      <Header_New></Header_New>
          {/* Background Animation Layer */}
        <div className="background-animation">
          <div class="area" >
              <ul class="circles">
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
              </ul>
          </div >
        </div>
        <Link to="/bookchoice" className="try-it-banner">
          Probier es
        </Link>
        <div className="content-section">
          {contentBlocks.map((block, index) => (
            <div
              key={index}
              className="content-block"
              data-aos="fade-up"
              style={{ marginLeft: randomMargins[index] }}
            >
              {block.headerText && <div className="header-text">{block.headerText}</div>}
              {block.quote && <div className="quote">{block.quote}</div>}
              {block.paraText && <div className="para-text">{block.paraText}</div>}
            </div>
          ))}
        </div>
      </div>
      <div className="mobile-warning">
          Bitte drehen sie ihr Gerät<img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2FturnLandscape.png?alt=media&token=5c863abc-d04b-4bb1-9639-53b4056b88f5"></img>
      </div>
    </div>
  );
};

export default Imprint;